<template>
  <div>
    <div v-if=" (GET_ORDER_DETAIL_SIGNEDIN_RES!=null) || (GET_ORDER_DETAIL_RES!=null)">
      <cBookingStatus :bookingStatus="page" ></cBookingStatus>
    </div>

    <!-- <cAlertModal
      :show="isAlert"
      :status="1"
      :buttonList="[
                {name:$t('paymentPage.okButton'),func:navigateToSearch,color:'success'},]"
      
      :desc="alertValue"
    ></cAlertModal>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { COMPONENT_NAME, PATHNAME } from "../../../../util/constants";
import { addClassToBody, removeClassBody } from "../../../../util/util";
import apiGetOrderSignedIn from "../../../../services/apiGetOrderSignedIn.js";
import apiGetOrderDetails from "../../../../services/apiGetOrderDetails.js";

import cBookingStatus from "../../../../components/confirmation/cBookingStatus";
import Logger from "../../../../services/logger";
import cAlertModal from "../../../../components/form/cAlertModal";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import Vue from "vue";
import {
  ROUTER_PARAM,
  PAYMENT_PROCEED_TO,
  PROCEED_TO_TYPE
} from "../../../../util/constants";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import BaseConfiguration from "../../../../config/base";
import router, {
  navigate,
  navigateReplace,
  goBack
} from "../../../../router/index";
import {
  handleJWT,
  getErrorAlertValue,
  handleSessionExist
} from "../../../../util/util";

export default {
  components: {
    cBookingStatus,
    cAlertModal
  },
  data: () => ({
    page: "SuccessPage",
    isAlert: false,
    alertValue: null,
    apiCallCount: 0,
    token: null
  }),
  computed: {
    ...mapGetters("sPaymentPage", {
      GET_CREATE_BOOKING_RES: "GET_CREATE_BOOKING_RES",
      GET_ORDER_DETAIL_RES: "GET_ORDER_DETAIL_RES",
      GET_ORDER_DETAIL_SIGNEDIN_RES: "GET_ORDER_DETAIL_SIGNEDIN_RES"
    })
  },
  methods: {
    ...mapActions("sPaymentPage", {
      SET_ORDER_DETAIL_SIGNEDIN_RES: "SET_ORDER_DETAIL_SIGNEDIN_RES"
    }),
  ...mapActions("sResult", {
      SET_AIRLINES:"SET_AIRLINES",
      
    }),
    /// getOrderDetail_signedIn api (to be called before navigating to success and hold page)
    async getOrderDetailsSignedIn(pOrderId, pOrderPayId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getOrderDetailsSignedIn");
        let orderDetReq = apiGetOrderSignedIn.buildRequest(
          pOrderId,
          pOrderPayId
        );

        if (orderDetReq) {
          let orderRes = await apiGetOrderSignedIn.getResponse(orderDetReq);

          if (VALIDATE_SUCCESS_RES(orderRes)) {
            retValue = orderRes.data;
            if(retValue.data&&retValue.data.airlines){
                         this.SET_AIRLINES(retValue.data.airlines);
                        }
            this.SET_ORDER_DETAIL_SIGNEDIN_RES(retValue);

            this.loggerFunc();
          } else {
            //if status error
            retValue = orderRes.data;

            let error = getErrorMessage(orderRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              let isSessionExpired;
              if(orderRes) {
                isSessionExpired = handleSessionExist(orderRes.data);
              }
              if (!isSessionExpired) {
                // this.alertValue=getErrorAlertValue(error);
                this.SET_ORDER_DETAIL_SIGNEDIN_RES(retValue);
                if (retValue.data.proceedTo) {
                  this.navByProceedTo(retValue.data);
                }
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SUCCESSPAGE,
          "error in getOrderDetailsSignedIn",
          err.toString(),
          "getOrderDetailsSignedIn",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getOrderDetails(pToken) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getOrderDetails");
        let orderDetReq = apiGetOrderDetails.buildRequest(pToken);

        if (orderDetReq) {
          let orderRes = await apiGetOrderDetails.getResponse(orderDetReq);

          if (VALIDATE_SUCCESS_RES(orderRes)) {
            retValue = orderRes.data;
          } else {
            //if status error
            retValue = orderRes.data;

            let error = getErrorMessage(orderRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              // let isSessionExpired = handleSessionExist(orderRes.data);
              let isSessionExpired;
              if(orderRes) {
                isSessionExpired = handleSessionExist(orderRes.data);
              }
              if (!isSessionExpired) {
                // this.alertValue=getErrorAlertValue(error);
                // this.SET_ORDER_DETAIL_RES(retValue);
                // if(retValue.data.proceedTo) {
                // this.navByProceedTo(retValue.data);
              } else {
                navigate(PATHNAME.FAILEDPAGE);
                throw "Undefined proceed to from createBooking api response";
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.BOOKING_STATUS_PAGE,
          "error in getOrderDetails",
          err.toString(),
          "getOrderDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    emitFunction(ticketNumbers) {
      this.$root.$emit("gotTickerNumber", ticketNumbers);
      if (BaseConfiguration.isDebug) console.log("gotTickerNumber---------Emitted");
    },

    /// Logger the pnr and order id if there is no ticket numbers in response incase of success case
    loggerFunc() {
      try {
        if (BaseConfiguration.isDebug) console.log("loggerFunc");
        let body = [];
        if (
          this.GET_ORDER_DETAIL_RES &&
          this.GET_ORDER_DETAIL_RES.data.ticketNumbers &&
          this.GET_ORDER_DETAIL_RES.data.ticketNumbers.length == 0
        ) {
          body.push(
            this.GET_ORDER_DETAIL_RES.data.pnr.toString(),
            this.GET_ORDER_DETAIL_RES.data.orderID,
            "has no ticket number"
          );

          throw body;
        } else if (
          this.GET_ORDER_DETAIL_SIGNEDIN_RES &&
          this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.ticketNumbers &&
          this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.ticketNumbers.length == 0
        ) {
          body.push(
            this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.pnr.toString(),
            this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.orderID,
            "has no ticket number"
          );

          throw body;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.BOOKING_STATUS_PAGE,
          "has no ticket number",
          err.toString(),
          "loggerFunc",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toGetTicketNumber(papiCallCount, pToken) {
      try {
        if (BaseConfiguration.isDebug) console.log("toGetTicketNumber");
        let count = papiCallCount;

        let that = this;

        let intervalTime = setInterval(async function() {
          if(count<3){
          let orderDetailsRes = await that.getOrderDetails(pToken);
          if (orderDetailsRes && orderDetailsRes.data) {
            if (
              orderDetailsRes &&
              orderDetailsRes.data &&
              orderDetailsRes.data.ticketNumbers &&
              orderDetailsRes.data.ticketNumbers.length != 0 &&
              count < 3
            ) {
              clearInterval(intervalTime);
              that.emitFunction(orderDetailsRes.data.ticketNumbers);
              count = 3;
            } else {
              count = count + 1;
              if (count == 3) {
                clearInterval(intervalTime);
                that.apiCallCount = count;
                that.$root.$emit("gotApiCallCount", that.apiCallCount);
              }
            }
          }
          }
        }, 20000);

        //  console.error(this.apiCallCount)
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SUCCESSPAGE,
          "error in toGetTicketNumber",
          err.toString(),
          "toGetTicketNumber",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },

  mounted() {
    //  this.$root.$emit("toggle-fixed-header", true);
    this.$root.$emit("toggle-sidebar-minimize");
  },

  async created() {
    try {
      let body;
      if (BaseConfiguration.isDebug) console.log("created");
      this.$root.$emit("toggle-sidebar-minimize");

      if (this.GET_ORDER_DETAIL_RES != null) {
        //call api countinouly till we get the tkt numbers - on success case only
        if (
          this.GET_ORDER_DETAIL_RES &&
          this.GET_ORDER_DETAIL_RES.data &&
          (this.GET_ORDER_DETAIL_RES.data.ticketNumbers == null ||
            this.GET_ORDER_DETAIL_RES.data.ticketNumbers.length == 0)
        ) {
          this.toGetTicketNumber(
            this.apiCallCount,
            this.GET_ORDER_DETAIL_RES.token
          );
        }
      } else if (
        this.GET_CREATE_BOOKING_RES != null &&
        this.GET_ORDER_DETAIL_RES == null
      ) {
        if (
          this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderId &&
          this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderPaymentId
        ) {
          let orderSignedInRes = await this.getOrderDetailsSignedIn(
            this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderId,
            this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderPaymentId
          );

          if (
            orderSignedInRes &&
            orderSignedInRes.data &&
            (orderSignedInRes.data.ticketNumbers == null ||
              orderSignedInRes.data.ticketNumbers.length == 0)
          ) {
            let that = this;

            let intervalTime = setInterval(async function() {
              if(that.apiCallCount<3){
              orderSignedInRes = await that.getOrderDetailsSignedIn(
                that.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderId,
                that.GET_CREATE_BOOKING_RES.data.data.bookingStatus
                  .orderPaymentId
              );
              if (
                orderSignedInRes &&
                orderSignedInRes.data &&
                orderSignedInRes.data.ticketNumbers &&
                orderSignedInRes.data.ticketNumbers.length != 0 &&
                that.apiCallCount<3
              ) {
                clearInterval(intervalTime);
                that.emitFunction(orderSignedInRes.data.ticketNumbers);
                that.apiCallCount=3;
              } else {
                that.apiCallCount = that.apiCallCount + 1;
                if (that.apiCallCount == 3) {
                  clearInterval(intervalTime);
                  that.$root.$emit("gotApiCallCount", that.apiCallCount);
                }
              }
            }
            }, 20000);
          }
        }
        /// if there is no order id and order payment id, navigate to failed page
        else {
          body.push(
            "has no order id or order payment id in createbooking api response"
          );

          navigate(PATHNAME.FAILEDPAGE);
          throw body;
        }
      }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.SUCCESSPAGE,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  beforeCreate() {
    addClassToBody(COMPONENT_NAME.SUCCESSPAGE);
  },

  beforeDestroy() {
    this.$root.$emit("toggle-sidebar-minimize", true);

    removeClassBody();
  },
  destroyed() {
    //  this.$root.$emit("toggle-sidebar", false);
    /* if(router.currentRoute.path!=PATHNAME.DASHBOARD && router.currentRoute.path!=PATHNAME.FLIGHTRESULTS)
               router.replace({path:PATHNAME.DASHBOARD})*/
  }
};
</script>


